import request from '@/lib/request';
import qs from 'qs';

export function getUserInfo() {
  return request.get('/admin/user');
}

export function login(params) {
  return request.get('/wechat/login', params);
}

export function login2(params) {
  return request.get(`/v4/admin/login?${qs.stringify(params)}`);
}

export function getOrderList(params) {
  return request.post('/user/orders', params);
}

export function getOrders(params = {}) {
  return request.post('/nlp/user/order', params);
}

export function setUserInfo(params) {
  return request.post('/user/info', params);
}

export function getSmsCode(params) {
  return request.post('/user/sms/send', params);
}

export function getProductList() {
  return request.get('/user/products?purpose=PC_实证分析');
}

export function getOrderDetail(query) {
  return request.get(`/wechat/order/${query}`);
}

export function getPayOrderCode(params) {
  return request.post('/orders/buy', params);
}

export function setValid(params) {
  return request.post('/user/valid', params);
}

export function setLogout() {
  return request.get('/admin/logout');
}

export function getWxQrCode(params = {}) {
  return request.post('/wechat/qrCode', params);
}

export function getWxOfficialLogin(key) {
  return request.get('/wechat/official/login?key=' + key);
}
